import React from "react";

const GeneralInformation = () => {
  return (
    <>
      <div>
        <h6 className="fw-bold mb-3">General Information:</h6>

        <ul
          className="ps-3 mb-0"
          style={{ lineHeight: "2.5", listStyle: "disc", color: "#000" }}
        >
          <li>
            Please click on "Fill Applicant Form" button to complete the
            background screening application form & upload all relevant
            documents.
          </li>

          <li>
            If you are required to upload multiple documents for
            employment,education or other component, please upload a zip folder.
          </li>

          <li>
            Please mention the exact last working date with your previous
            employers to avoid any errors.
          </li>

          <li>
            You will be able to make changes in the details filled in the
            application form, until you click on "Final Submit". Post final
            submission, the portal will not allow you to edit the form.
          </li>

          <li>
            You are requested to complete the application form at the earliest,
            to ensure faster onboarding at employer's end.
          </li>

          <li>
            Once you submit the application form, it will be reviewed by your
            respective HR officials & they may reject the application form if
            they find any information missing. You may be required to re-login
            and update the application form as per their instructions.
          </li>

          <li>
            We recommend to keep your User ID and Password accessible as you may
            be required to re-login to update the application form at a later
            stage.
          </li>

          <li>
            2 factor authentication is enabled on your email & phone for
            security
          </li>
          <li>
            If you face any error or pop-up which doesn't allow you to proceed
            further with your application form, please send an incident email
            at:{" "}
            <a
              href="mailto: candidatesupport@aupertz.co.in"
              className="text-danger"
            >
              candidatesupport@aupertz.co.in
            </a>{" "}
            with a screenshot of the error message and include your 'Case ID'
            and 'Client Name' (mentioned on the home page - top left){" "}
          </li>
        </ul>
      </div>
    </>
  );
};

export default GeneralInformation;
